import React from 'react';
import PropTypes from 'prop-types';
import { MaintenanceWidget } from './MaintenanceWidget';

export const Widget = props => {
  return <MaintenanceWidget {...props} />;
};

Widget.displayName = 'utility/MaintenanceWidget';

Widget.propTypes = {
  data: PropTypes.shape({
    headingText: PropTypes.string,
    detailsText: PropTypes.string,
  }),
};

Widget.defaultProps = {
  data: {
    headingText: `We'll be right back!`,
    detailsText:
      'We sincerely apologize for the inconvenience. Our site is currently undergoing scheduled maintenance and upgrades, but will return shortly. Thank you for your patience.',
  },
};
